import axios from "axios";
import { toast } from "react-toastify";
import authStore from "stores/auth/AuthStore";
// import { useStore } from "stores/useStore";

const baseURL = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_BASE_API}`;

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    // const url = error.config?.url;
    const message = error.response?.data?.message;
    const token = localStorage.getItem("token");
    const isLoginPage = window.location.pathname === "/";
    const type = error.response?.data?.type;

    if (!error.response) {
      toast.warning("Le serveur est injoignable.");
      return Promise.reject(error);
    }

    switch (status) {
      case 400:
        toast.error(message || "Requête invalide.");
        break;
      case 401:
        if (token && !isLoginPage) {
          toast.warning("Session expirée. Redirection en cours...");
          authStore?.logout();
          // window.location.href = "/";
        } else {
          toast.error(message || "Accès non autorisé.");
        }
        break;
      case 403:
        if (type === "role_changed") {
          toast.error(
            message || "Votre rôle a changé. Veuillez vous reconnecter.",
          );
          authStore?.logout();
          // window.location.href = "/";
        } else if (type === "account_inactive") {
          toast.error(message || "Votre compte a été désactivé ou supprimé.");
          authStore?.logout();
          // window.location.href = "/";
        } else {
          toast.error(
            message ||
              "Accès refusé. Vous n'avez pas les autorisations nécessaires.",
          );
        }
        break;
      case 404:
        toast.error(message || "Ressource non trouvée.");
        break;
      case 500:
        toast.error(message || "Erreur interne du serveur.");
        break;
      default:
        if (!isLoginPage) toast.error(message || "Une erreur s'est produite.");
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
